<!-- Button -->
<button
    mat-icon-button
    [attr.aria-label]="actionLabel"
    [matTooltip]="actionLabel"
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="actionIcon"></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"
        ></span>
    </span>
</button>

<!-- Hidden controller only: never nest its icon button inside the menu item. -->
<fuse-fullscreen *ngIf="showFullscreen" style="display: none" aria-hidden="true"></fuse-fullscreen>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Registrado como</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="linkProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Perfil</span>
    </button>
    <button *ngIf="showFullscreen" mat-menu-item (click)="toggleFullscreen()">
        <mat-icon [svgIcon]="'heroicons_outline:arrows-expand'"></mat-icon>
        <span>Pantalla completa</span>
    </button>
    <button *ngIf="showHelp" mat-menu-item [routerLink]="['/help']">
        <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
        <span>Ayuda</span>
    </button>
    <button *ngIf="user.rol === 0"
            mat-menu-item>
        <a href="https://util-taxgm.s3.amazonaws.com/sise/manuals/MANUAL_USUARIO_MASTER.pdf"
           target="_blank">
            <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
            <span>Manual de usuario</span>
        </a>
    </button>
    <button *ngIf="user.rol === 5"
            mat-menu-item>
        <a href="https://util-taxgm.s3.us-east-1.amazonaws.com/sise/manuals/MANUAL_USUARIO_SEMI_MASTER.pdf"
           target="_blank">
            <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
            <span>Manual de usuario</span>
        </a>
    </button>
    <button *ngIf="user.rol === 1 || user.rol === 2"
            mat-menu-item>
        <a href="https://sise-util.s3.us-east-1.amazonaws.com/manuals/MANUAL_DE_USUARIO_COMPA%C3%91%C3%8DA.pdf"
           target="_blank">
            <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
            <span>Manual de usuario</span>
        </a>
    </button>
    <button *ngIf="user.rol === 3"
            mat-menu-item>
        <a href="https://sise-util.s3.us-east-1.amazonaws.com/manuals/MANUAL_DE_USUARIO_PROVEEDOR.pdf"
           target="_blank">
            <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
            <span>Manual de usuario</span>
        </a>
    </button>
    <button *ngIf="user.rol === 3" class="my-4"
            mat-menu-item>
        <a class="py-4"
           href="https://util-taxgm.s3.amazonaws.com/sise/manuals/GUIA_PARA_GENERAR_DOCUMENTOS_REQUERIDOS.pdf"
           target="_blank">
            <mat-icon [svgIcon]="'heroicons_outline:book-open'"></mat-icon>
            <span>Guía para generar<span class="block leading-3 pb-5">documentos requeridos</span></span>
        </a>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>Salir</span>
    </button>
</mat-menu>
<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
